import React from 'react';
import { connect } from 'react-redux';

import { setOptions } from 'src/reducers/selectOptions';
import CustomFeatureForm from './Components/CustomFeatureForm';

export const NewCustomFeature = ({ extraAttributes, dispatch, values, match }) => {
  dispatch(
    setOptions({
      ...extraAttributes,
    })
  );
  return (
    <div className="l-wrap-xl">
      <h2 style={{ marginBottom: '2rem' }}>New feature</h2>
      <CustomFeatureForm values={values?.clientCustomFeature} params={match.params}/>
    </div>
  );
};


export default connect()(NewCustomFeature);
